import { render, staticRenderFns } from "./resource-control.vue?vue&type=template&id=0b5a36bc"
import script from "./resource-control.vue?vue&type=script&lang=ts"
export * from "./resource-control.vue?vue&type=script&lang=ts"
import style0 from "./resource-control.vue?vue&type=style&index=0&id=0b5a36bc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports